import '@babel/polyfill';

import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import {createProvider} from './store/apollo/apollo';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import slugify from '@/filters/slugify';
import meta from '@/filters/meta';
import dateTime from '@/filters/dateTime';
import language from '@/filters/language';
import Meta from 'vue-meta';
import VCalendar from 'v-calendar-ie11';
import InfiniteLoading from 'vue-infinite-loading';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueGoogleCharts from 'vue-google-charts';
import DatePlugin from '@/plugins/Date';
import Email from '@/plugins/Email';
import Http from '@/plugins/Http';
import Permissions from '@/plugins/Permissions';
import copyDirective from '@/directive/Copy';
import VueWorker from 'vue-worker';
import VueShortkey from 'vue-shortkey';
import 'intersection-observer';
import VueSweetalert2 from 'vue-sweetalert2';
import VueKonva from 'vue-konva';
import Vuetify from 'vuetify';

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  release: `${process.env.VUE_APP_BUILD_MODE}-${process.env.VUE_APP_BUILD_NUMBER}-${process.env.VUE_APP_COMMIT_HASH}`,
  integrations: [new Integrations.Vue({Vue, attachProps: true})],
});

if (process.env.NODE_ENV === 'development') {
  Vue.config.performance = true;
  Vue.config.productionTip = false;
}

Vue.use(Meta, {
  refreshOnceOnNavigation: true,
});
Vue.use(VCalendar);
Vue.use(InfiniteLoading);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'drawing', // Maybe use 'places' (for autocomplete) and 'visualization' (for ?)
  },
  installComponents: true,
});

Vue.use(VueGoogleCharts);
Vue.use(VueWorker);
Vue.use(VueShortkey);

// gripper extras
Vue.use(VueSweetalert2);

Vue.use(DatePlugin);
Vue.use(Email);
Vue.use(Http);
Vue.use(Permissions, store);

Vue.use(VueKonva);

Vue.directive('copy', copyDirective);

Vue.filter('dateTime', dateTime);
Vue.filter('meta', meta);
Vue.filter('slugify', slugify);
Vue.filter('language', language);
Vue.use(Vuetify);

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  vuetify: new Vuetify(),
  render: (h) => h(App),
}).$mount('#app');
